<template>
  <li class="product-list__item">
    <a href="#" v-on:click.prevent="getProduct(product.Id, category)">{{product.Name}}</a>
  </li>
</template>

<script>
export default {
  props: ["product", "category"],
  methods: {
    getProduct (productId, categoryId) {
      if (this.$route.params.fileTypeId) {
        this.$router.go("/documents/" + this.$route.params.fileTypeId + "/" + categoryId + "/" + productId);
      } else {
        this.$router.go("/images/product/" + productId);
      }
    }
  }
};
</script>

<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .product-list{
    &__item{
      display: block;

      a{
        color: $white;
      }

      &:last-child{
        margin-right: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProductsListItem.vue?01e0d1a9